export default "__VITE_ASSET__iWfzYMuv__"